/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React from 'react';

/**
 * Root Imports
*/

import { CssClassName } from '~/util/Css';

/**
 * Exports/
*/

/**
 * 
 */
export function Buttons({ className, formik, ...props }) {
  /** Settings **/

  const config = {
    className: CssClassName(props.className),
    formik: formik,
    children: props.children
  };

  /** Output **/

  return typeof props.container === 'function'
    ? React.createElement(props.container, config)
    : React.cloneElement(props.container, config)
  ;
}

Buttons.propTypes = {
  container: PropTypes.oneOfType([ PropTypes.node, PropTypes.func ]),
  className: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
  formik: PropTypes.object
};

Buttons.defaultProps = {
  container: <div/>
};